"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _useBuildDate = require("../../../src/hooks/use-build-date");

function BuildDate() {
  var buildDate = (0, _useBuildDate.useBuildDate)();
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, buildDate)
  );
}

var _default = BuildDate;
exports["default"] = _default;